import React, {useState, useEffect, useRef, useCallback} from 'react';
import axios from 'axios';
import './ManagePage.css'
import DoubleClickText from './DoubleClickText';
import { getProductDisplayName } from '../../utils/productNames';


const hrStyle = {width: '100%', border: '0.5px solid #3c3c3c'};
const sectionLabelStyle = {fontSize: 12, textAlign: 'center'};
const textInputStyle = {backgroundColor: '#212121', color: '#969696', border: '0px', borderRadius: '2px'};
const selectStyle = {backgroundColor: 'black', color: 'white', borderColor: '#969696'};
const tableInputStyle = {...textInputStyle, fontSize: 11, padding: '2px 6px'};
const thStyle = {
    padding: '6px 8px', textAlign: 'center', verticalAlign: 'middle',
    fontSize: 11, fontWeight: 'bold', color: '#969696',
    borderBottom: '1px solid #3c3c3c', whiteSpace: 'nowrap',
};
const tdStyle = {
    padding: '6px 8px', textAlign: 'center', verticalAlign: 'middle',
    fontSize: 11, color: '#969696', borderBottom: '1px solid #222',
};

const toDateInputValue = (iso) => {
    if (!iso) return '';
    return new Date(iso).toISOString().slice(0, 10);
};

function FeatureMultiSelect({allFeatures, selectedFeatures, onChange}) {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target))
                setOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const isDisabled = allFeatures.length === 0;

    const label = `${selectedFeatures.length} selected`;

    const toggle = (feature, checked) => {
        const updated = checked
            ? [...selectedFeatures, feature]
            : selectedFeatures.filter(f => f.id !== feature.id);
        onChange(updated);
    };

    return (
        <div ref={containerRef} style={{position: 'relative', display: 'inline-block'}}>
            <button
                disabled={isDisabled}
                onClick={() => setOpen(o => !o)}
                style={{
                    ...textInputStyle,
                    padding: '2px 6px', fontSize: 11, minWidth: 100, textAlign: 'left',
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    opacity: isDisabled ? 0.4 : 1,
                }}
            >{label} ▾</button>
            {open && (
                <div style={{
                    position: 'absolute', zIndex: 100, top: '100%', left: 0,
                    backgroundColor: '#1a1a1a', border: '1px solid #3c3c3c',
                    borderRadius: 2, padding: '4px 0', minWidth: 160,
                }}>
                    {allFeatures.map(f => (
                        <label key={f.id} style={{display: 'flex', alignItems: 'center', gap: 6, padding: '3px 10px', cursor: 'pointer', fontSize: 11, color: '#969696'}}>
                            <input
                                type="checkbox"
                                checked={selectedFeatures.some(sf => sf.id === f.id)}
                                onChange={(e) => toggle(f, e.target.checked)}
                            />
                            {f.name}
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
}


/**
 * Group List
 */

function UserGroupList({userGroups, selectedUserGroup, setSelectedUserGroup, setSelectedUser, reloadUserGroupTable, reloadUserTable}) {
    const selectRow = (event) => {
        setSelectedUser('');
        if (event.target.id)
            setSelectedUserGroup(event.target.id);
        else if (event.target.parentElement.id)
            setSelectedUserGroup(event.target.parentElement.id)
        else
            setSelectedUserGroup("")
    }

    const addUserGroup = () => {
        console.log("Add User Group")
        const token = localStorage.getItem('token');
        axios.post('/api/userGroups/', {'name':"User Group" + userGroups.length}, {
            headers: {
                'Authorization': `Token ${token}`,
                 'Content-Type': 'application/json'
            },
        })
        .then(response => {
            console.log("success: ", response)
            reloadUserGroupTable();
        })
        .catch(error => {
            console.log("Error: ", error)
            reloadUserGroupTable()
        });
    }

    const removeSelectedUserGroup = () => {
        const token = localStorage.getItem('token');
        axios.delete('/api/userGroups/' + selectedUserGroup + "/", {
            headers: {
                'Authorization': `Token ${token}`,
                 'Content-Type': 'application/json'
            },
        })
        .then(response => {
            console.log("success: ", response)
            reloadUserGroupTable()
            reloadUserTable();
        })
        .catch(error => {
            console.log("Error: ", error)
            reloadUserGroupTable()
            reloadUserTable();
        });
    }


    const userGroupNameDidChange = (id, name) => {
        const token = localStorage.getItem('token');
        axios.put('/api/userGroups/' + id + "/", {'name': name}, {
            headers: {
                'Authorization': `Token ${token}`,
                 'Content-Type': 'application/json'
            },
        })
        .then(response => {
            console.log("success: ", response)
            reloadUserGroupTable()
        })
        .catch(error => {
            console.log("Error: ", error)
            reloadUserGroupTable()
        });
    }

    const allColor = selectedUserGroup === "" ? '#3c3c3c' : 'black';

    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: '200px',
            gridTemplateRows: "10px 10px 600px 10px 20px",
            gridGap: '0px',
            margin:0,
        }}>
            <label style={{textAlign:'left', fontWeight:'bold', fontSize:10}}>User Groups</label>
            <hr style={hrStyle}/>
            <div>
                <table style={{ overflowY:'scroll', height:'100%', display:"block"}}>
                    <tbody>
                        <tr style={{borderRadius:'2px', justifyItems:'start', backgroundColor:allColor}}>
                            <td style={{ padding:'5px', borderRadius:'2px', width:'200px'}} onClick={selectRow}>
                                <label style={{fontSize:'12px', textAlign:'left' }} onClick={selectRow}>All</label>
                            </td>
                        </tr>
                    {
                        userGroups.map((userGroup) => {
                            const selectedColor = String(userGroup.id) === selectedUserGroup ? '#3c3c3c' : 'black';
                            return (
                                <tr style={{borderRadius:'2px', justifyItems:'start', backgroundColor:selectedColor}} key={userGroup.id} onClick={selectRow}>
                                    <td style={{ padding:'5px', borderRadius:'2px', width:'200px', backgroundColor:selectedColor}} key={userGroup.name+1} id={userGroup.id}>
                                    <DoubleClickText type='text' style={{borderRadius:'2px'}} color={selectedColor}
                                             id={userGroup.id} key={userGroup.name+2} initialText={userGroup.name} didSet={userGroupNameDidChange}/>
                                    </td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
            <hr style={hrStyle}/>
            <div style={{display:'grid', gridTemplateColumns:'30px 30px', justifyContent:'end'}}>
                <button className='ManagePage-AddButton' onClick={()=>{
                    if (window.confirm('Are you sure you want to remove user group? This will remove all associated users'))
                        removeSelectedUserGroup();
                }}>-</button>
                <button className='ManagePage-AddButton' onClick={addUserGroup}>+</button>
            </div>
        </div>
    )
}



/**
 * Model Window for Adding New Users
 */
function NewUserModal({setShowAddNewUser, selectedUser, setSelectedUser, reloadTable}) {
    const [email, setEmail] = useState('');
    const [firstname, setFirstName] = useState('');
    const [lastname, setLastName] = useState('');

    const emailDidChange = (event) => {setEmail(event.target.value)}
    const firstNameDidChange = (event) => {setFirstName(event.target.value)}
    const lastNameDidChange = (event) => {setLastName(event.target.value)}

    const AddNewUser = () => {
        const userInfo = {
            'username': email.toLowerCase().trim(),
            'email': email.toLowerCase().trim(),
            'firstname': firstname.trim(),
            'lastname': lastname.trim(),
        }

        const token = localStorage.getItem('token');
        axios.post('/api/addNewUser/', userInfo, {
            headers: {
                'Authorization': `Token ${token}`,
                 'Content-Type': 'application/json'
            },
        })
        .then(response => {
            console.log(response)
            setSelectedUser(email)
            reloadTable();
        })
        .catch(error => {
            console.log("Error");
            setSelectedUser(selectedUser)
            reloadTable();
        });

        setShowAddNewUser(false);
    }

    return (
        <div style={{backgroundColor:'black',color:'#555555',
                    position:'absolute', left:'50%', top:'25%',
                    transform:'translate(-50%, -50%)',
                    border:'1px solid #3c3c3c',
                    justifyContent:'center'
                    }}>
                    <h4 style={{padding:0}}>Add New User</h4>
            <div style={{
                display:'grid',
                gridTemplateColumns: '90px 250px',
                gridTemplateRows: 'auto auto, auto, auto, auto',
                gridRowGap: '10px',
                gridColumnGap: '10px',
                color:'#969696',
                padding:20,
            }}>
                <label style={{height:25, fontSize:12, textAlign:'right'}}>Email Address:</label>
                <input type='text' style={{...textInputStyle, height:25, paddingLeft:10}} placeholder='email' value={email} onChange={emailDidChange}/>
                <label style={{height:25, fontSize:12, textAlign:'right'}}>First Name:</label>
                <input type='text' style={{...textInputStyle, height:25, paddingLeft:10}} placeholder='firstname' value={firstname} onChange={firstNameDidChange}/>
                <label style={{height:25, fontSize:12, textAlign:'right'}}>Last Name:</label>
                <input type='text' style={{...textInputStyle, height:25, paddingLeft:10}} placeholder='lastname' value={lastname} onChange={lastNameDidChange}/>
                <div/>
                <div style={{display:'grid', gridTemplateColumns:'auto auto'}}>
                    <button className='ManagePage-SaveButton' onClick={()=>{setShowAddNewUser(false)}}>Cancel</button>
                    <button className='ManagePage-SaveButton' style={{marginLeft:5}} onClick={AddNewUser}>Add New User</button>
                </div>
            </div>
        </div>
    )
}


/**
 * Details of a users profile
 */
function UserDetails({selectedUser, reloadTable, userGroups}) {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [firstname, setFirstName] = useState('');
    const [lastname, setLastName] = useState('');
    const [, setCategoryName] = useState('');
    const [categoryUuid, setCategoryUuid] = useState(-1);
    const [userDidChange, setUserDidChange] = useState(false)
    const [resendPasswordText, setResendPasswordText] = useState('Reset Password')
    const [saveDataText, setSaveDataText] = useState('Save Changes')
    const [errorMessage, setErrorMessage] = useState('')


    const resetFields = () => {
        setUsername(''); setEmail(''); setFirstName(''); setLastName('');
        setCategoryName(''); setCategoryUuid(''); setUserDidChange(false); setErrorMessage('');
    };

    useEffect(() => {
        if (!selectedUser) { resetFields(); return; }

        const token = localStorage.getItem("token");
        axios.get('/api/users/' + selectedUser, {
            headers: {'Authorization': `Token ${token}`},
        })
        .then(response => {
            if (response.status === 200) {
                setUserDidChange(false);
                setUsername(response.data.username ?? '')
                setEmail(response.data.email ?? '')
                setFirstName(response.data.firstname ?? '')
                setLastName(response.data.lastname ?? '')
                setCategoryName(response.data.usergroupname ?? '')
                setCategoryUuid(response.data.usergroupid ?? '')
                setErrorMessage('')
            } else {
                resetFields();
            }
        })
        .catch(error => { resetFields(); setErrorMessage(error); });
    }, [selectedUser])

    const emailDidChange = (event) => {
        setEmail(event.target.value)
        setUserDidChange(true);
    }

    const firstNameDidChange = (event) => {
        setFirstName(event.target.value)
        setUserDidChange(true);
    }

    const lastNameDidChange = (event) => {
        setLastName(event.target.value)
        setUserDidChange(true);
    }

    const categoryDidChange = (event) => {
        setCategoryUuid(event.target.value);
        console.log("change", event.target.value)
        setUserDidChange(true);
    }


    // Save User Information
    const saveUser = () => {
        const userInfo = {
            'username': username.toLowerCase(),
            'email': email.toLowerCase(),
            'firstname': firstname,
            'lastname': lastname,
            'usergroupid': categoryUuid,
        }

        setSaveDataText('Saving...')
        setTimeout(()=> {
            setSaveDataText('Save Changes');
        }, 5000)

        const token = localStorage.getItem('token');
        axios.post('/api/updateUser/', userInfo, {
            headers: {
                'Authorization': `Token ${token}`,
                 'Content-Type': 'application/json'
            },
            params: {'user': selectedUser},
        })
        .then(response => {
            setErrorMessage("");
            setSaveDataText('Saved!')
            setUserDidChange(false);
            reloadTable();
        })
        .catch(error => {
            setErrorMessage(error);
            setSaveDataText('Did Not Save...')
            setUserDidChange(false);
            reloadTable();
        });
    }


    // Reset and Send Password to User
    const resendPassword = () => {
        setResendPasswordText('Sent New Password to User!')
        setTimeout(()=> {
            setResendPasswordText('Reset Password');
        }, 5000)

        const userInfo = {
            'email': email,
        }

        const token = localStorage.getItem('token');
        axios.post('/api/resendUserPassword/', userInfo, {
            headers: {
                'Authorization': `Token ${token}`,
                 'Content-Type': 'application/json'
            },
        })
        .then(response => {
            setErrorMessage("")
        })
        .catch(error => {
            setErrorMessage(error)
        });
    }


    const disabled = !userDidChange;

    return (
        <div style={{
            display:'grid',
            gridTemplateColumns: '100px 400px',
        }}>
            <div>
                <label style={sectionLabelStyle}>PROFILE</label>
            </div>
            <div style={{
                display:'grid',
                gridTemplateColumns: '150px 250px',
                gridTemplateRows: '30px, 30px, 30px, 30px 30px 30px',
                gridRowGap: '10px',
                gridColumnGap: '10px',
                margin: 10,
                color:'#969696',
                fontSize:12,
            }}>
                <label style={{fontSize:12, textAlign:'right'}}>Email Address:</label>
                <input type='text' style={{...textInputStyle, paddingLeft:10}} placeholder='email' value={email} onChange={emailDidChange}/>
                <label style={{fontSize:12, textAlign:'right'}}>First Name:</label>
                <input type='text' style={{...textInputStyle, paddingLeft:10}} placeholder='firstname' value={firstname} onChange={firstNameDidChange}/>
                <label style={{fontSize:12, textAlign:'right'}}>Last Name:</label>
                <input type='text' style={{...textInputStyle, paddingLeft:10}} placeholder='lastname' value={lastname} onChange={lastNameDidChange}/>
                <label style={{fontSize:12, textAlign:'right'}}>User Group:</label>
                <select value={categoryUuid} onChange={categoryDidChange} style={selectStyle}>
                    <option value={''}>None</option>
                    {userGroups.map((option) => {
                        return (
                            <option key={option.id} value={option.id} style={{backgroundColor:'black'}}>
                                {option.name}
                            </option>
                    )}
                )}
                </select>
                <div/>
                <button className='ManagePage-SaveButton' onClick={saveUser} disabled={disabled}>{saveDataText}</button>
                <div/>
                <button className='ManagePage-SaveButton' onClick={resendPassword}>{resendPasswordText}</button>
                <div/>
                <label style={{color:'red'}}>{errorMessage}</label>

            </div>
        </div>
    )
}


function AddEntitlementModal({availableProducts, allFeatures, addEndpoint, onClose, onAdded}) {
    const [draft, setDraft] = useState({
        product: null,
        features: [],
        license_type: 'subscription',
        grace_period_days: 15,
        max_num_activations: 1,
        valid_until: null,
        notes: '',
    });
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const update = (fields) => setDraft(prev => ({...prev, ...fields}));

    const handleAdd = () => {
        if (!draft.product) { setError('Select a product.'); return; }
        if (!addEndpoint) { setError('No user or group selected.'); return; }
        setSaving(true);
        const token = localStorage.getItem('token');
        axios.post(addEndpoint, {
            product: draft.product.id,
            license_type: draft.license_type,
            grace_period_days: draft.grace_period_days,
            max_num_activations: draft.max_num_activations,
            valid_until: draft.valid_until,
            revoked: draft.revoked,
            features: draft.features.map(f => f.id),
            notes: draft.notes,
        }, {
            headers: {'Authorization': `Token ${token}`, 'Content-Type': 'application/json'},
        })
        .then(response => { onAdded(response.data); onClose(); })
        .catch(() => { setError('Failed to add license.'); setSaving(false); });
    };

    return (
        <div style={{
            position: 'fixed', inset: 0,
            backgroundColor: 'rgba(0,0,0,0.85)',
            zIndex: 100,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
        <div style={{backgroundColor: 'black', color: '#555555', border: '1px solid #3c3c3c'}}>
            <h4 style={{padding: 0}}>Add License</h4>
            <div style={{padding: 20}}>
                <table style={{borderCollapse: 'collapse'}}>
                    <thead>
                        <tr>
                            <th style={thStyle}>License</th>
                            <th style={thStyle}>Features</th>
                            <th style={thStyle}>Type</th>
                            <th style={thStyle}>Grace<br/>Period</th>
                            <th style={thStyle}>Max<br/>Activations</th>
                            <th style={thStyle}>Valid Until</th>
                            <th style={thStyle}>Notes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={tdStyle}>
                                <select
                                    value={draft.product ? draft.product.id : ''}
                                    onChange={(e) => update({product: availableProducts.find(p => p.id === parseInt(e.target.value)) ?? null})}
                                    style={{...tableInputStyle, ...selectStyle}}
                                >
                                    <option value=''>— select —</option>
                                    {availableProducts.map(p => (
                                        <option key={p.id} value={p.id}>{getProductDisplayName(p.name)}</option>
                                    ))}
                                </select>
                            </td>
                            <td style={tdStyle}>
                                <FeatureMultiSelect
                                    allFeatures={allFeatures}
                                    selectedFeatures={draft.features}
                                    onChange={(f) => update({features: f})}
                                />
                            </td>
                            <td style={tdStyle}>
                                <select
                                    value={draft.license_type}
                                    onChange={(e) => update({license_type: e.target.value})}
                                    style={{...tableInputStyle, ...selectStyle}}
                                >
                                    <option value="trial">trial</option>
                                    <option value="subscription">subscription</option>
                                    <option value="perpetual">perpetual</option>
                                </select>
                            </td>
                            <td style={tdStyle}>
                                <input
                                    type="number" min="0"
                                    value={draft.grace_period_days ?? ''}
                                    onChange={(e) => update({grace_period_days: e.target.value !== '' ? Number(e.target.value) : null})}
                                    placeholder="days"
                                    style={{...tableInputStyle, width: 60}}
                                />
                            </td>
                            <td style={tdStyle}>
                                <input
                                    type="number" min="1"
                                    value={draft.max_num_activations}
                                    onChange={(e) => update({max_num_activations: e.target.value})}
                                    style={{...tableInputStyle, width: 50}}
                                />
                            </td>
                            <td style={tdStyle}>
                                <input
                                    type="date"
                                    value={toDateInputValue(draft.valid_until)}
                                    onChange={(e) => update({valid_until: e.target.value || null})}
                                    style={{...tableInputStyle, colorScheme: 'dark'}}
                                />
                            </td>
                            <td style={tdStyle}>
                                <input
                                    type="text"
                                    value={draft.notes}
                                    onChange={(e) => update({notes: e.target.value})}
                                    style={{...tableInputStyle, width: 150}}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <label style={{color: 'red', fontSize: 11}}>{error}</label>
                <div style={{display: 'flex', gap: 5, marginTop: 10}}>
                    <button className='ManagePage-SaveButton' onClick={onClose}>Cancel</button>
                    <button className='ManagePage-SaveButton' onClick={handleAdd} disabled={saving}>
                        {saving ? 'Adding...' : 'Add License'}
                    </button>
                </div>
            </div>
        </div>
        </div>
    );
}


function EntitlementsSection({assigneeId, listEndpoint, addEndpoint}) {
    const [entitlements, setEntitlements] = useState([]);
    const [allFeatures, setAllFeatures] = useState([]);
    const [allProducts, setAllProducts] = useState([]);
    const [pendingChanges, setPendingChanges] = useState({});
    const [saveText, setSaveText] = useState('Save Changes');
    const [showAddModal, setShowAddModal] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        axios.get('/api/features/', {
            headers: {'Authorization': `Token ${token}`},
        })
        .then(response => {
            if (response.status === 200)
                setAllFeatures(response.data.features);
        })
        .catch(() => setAllFeatures([]));

        axios.get('/api/products/', {
            headers: {'Authorization': `Token ${token}`},
        })
        .then(response => {
            if (response.status === 200)
                setAllProducts(response.data.products);
        })
        .catch(() => setAllProducts([]));
    }, []);

    useEffect(() => {
        if (!assigneeId) {
            setEntitlements([]);
            setPendingChanges({});
            return;
        }
        const token = localStorage.getItem('token');
        axios.get(listEndpoint, {
            headers: {'Authorization': `Token ${token}`},
        })
        .then(response => {
            if (response.status === 200) {
                setEntitlements(response.data.entitlements);
                setPendingChanges({});
            }
        })
        .catch(() => setEntitlements([]));
    }, [assigneeId, listEndpoint]);

    const recordChange = (id, fields) => {
        setPendingChanges(prev => {
            const existing = prev[id] ?? {};
            return {...prev, [id]: {...existing, ...fields}};
        });
    };

    const handleTypeChange = (id, newType) => {
        setEntitlements(prev => prev.map(e => e.id === id ? {...e, license_type: newType} : e));
        recordChange(id, {license_type: newType});
    };

    const saveChanges = () => {
        const token = localStorage.getItem('token');
        const headers = {'Authorization': `Token ${token}`, 'Content-Type': 'application/json'};
        const requests = Object.entries(pendingChanges).map(([id, fields]) =>
            axios.post('/api/updateEntitlement/', {id: parseInt(id), ...fields}, {headers})
        );
        setSaveText('Saving...');
        Promise.all(requests)
            .then(() => {
                setPendingChanges({});
                setSaveText('Saved!');
                setTimeout(() => setSaveText('Save Changes'), 3000);
            })
            .catch(() => {
                setSaveText('Error saving');
                setTimeout(() => setSaveText('Save Changes'), 3000);
            });
    };

    const hasChanges = Object.keys(pendingChanges).length > 0;

    return (
        <div style={{display: 'grid', gridTemplateColumns: '100px auto'}}>
            <div>
                <label style={sectionLabelStyle}>LICENSES</label>
            </div>
            <div style={{margin: 10}}>
                <table style={{borderCollapse: 'collapse'}}>
                    <thead>
                        <tr>
                            <th style={{...thStyle, minWidth: 180}}>License</th>
                            <th style={thStyle}>Features</th>
                            <th style={thStyle}>Type</th>
                            <th style={thStyle}>Grace<br/>Period</th>
                            <th style={thStyle}>Max<br/>Activations</th>
                            <th style={thStyle}>Current<br/>Activations</th>
                            <th style={thStyle}>Valid Until</th>
                            <th style={thStyle}>Revoked</th>
                            <th style={{...thStyle, minWidth: 160}}>Notes</th>
                            <th style={{...thStyle, minWidth: 250}}>Activation Keys</th>
                        </tr>
                    </thead>
                    <tbody>
                        {entitlements.length === 0 ? (
                            <tr>
                                <td colSpan={10} style={{...tdStyle, textAlign: 'center', color: '#555'}}>No licenses</td>
                            </tr>
                        ) : entitlements.map(entitlement => (
                            <tr key={entitlement.id}>
                                <td style={tdStyle}>{getProductDisplayName(entitlement.product.name)}</td>
                                <td style={tdStyle}>
                                    <FeatureMultiSelect
                                        allFeatures={allFeatures}
                                        selectedFeatures={entitlement.features}
                                        onChange={(updatedFeatures) => {
                                            setEntitlements(prev => prev.map(e => e.id === entitlement.id ? {...e, features: updatedFeatures} : e));
                                            recordChange(entitlement.id, {features: updatedFeatures.map(f => f.id)});
                                        }}
                                    />
                                </td>
                                <td style={tdStyle}>
                                    <select
                                        value={entitlement.license_type}
                                        onChange={(e) => handleTypeChange(entitlement.id, e.target.value)}
                                        style={{...tableInputStyle, ...selectStyle}}
                                    >
                                        <option value="trial">trial</option>
                                        <option value="subscription">subscription</option>
                                        <option value="perpetual">perpetual</option>
                                    </select>
                                </td>
                                <td style={tdStyle}>
                                    <input
                                        type="number"
                                        min="0"
                                        value={entitlement.grace_period_days ?? ''}
                                        onChange={(e) => {
                                            const val = e.target.value !== '' ? Number(e.target.value) : null;
                                            recordChange(entitlement.id, {grace_period_days: val});
                                            setEntitlements(prev => prev.map(ent => ent.id === entitlement.id ? {...ent, grace_period_days: val} : ent));
                                        }}
                                        placeholder="days"
                                        style={{...tableInputStyle, width: 60}}
                                    />
                                </td>
                                <td style={tdStyle}>
                                    <input
                                        type="number"
                                        min="1"
                                        value={entitlement.max_num_activations ?? ''}
                                        onChange={(e) => {
                                          recordChange(entitlement.id, { max_num_activations: e.target.value });
                                          setEntitlements(prev => prev.map(ent => ent.id === entitlement.id ? { ...ent, max_num_activations: e.target.value } : ent));
                                        }}
                                        style={{...tableInputStyle, width: 50}}
                                    />
                                </td>
                                <td style={tdStyle}>{entitlement.activation_count}</td>
                                <td style={tdStyle}>
                                    <input
                                        type="date"
                                        value={toDateInputValue(entitlement.valid_until)}
                                        onChange={
                                          (e) => {
                                            recordChange(entitlement.id, { valid_until: e.target.value || null });
                                            setEntitlements(prev => prev.map(ent => ent.id === entitlement.id ? { ...ent, valid_until: e.target.value || null } : ent));
                                          }
                                        }
                                style={{ ...tableInputStyle, colorScheme: 'dark' }}
                                    />
                                </td>
                                <td style={{...tdStyle, textAlign: 'center'}}>
                                    <input
                                        type="checkbox"
                                        checked={entitlement.revoked ?? false}
                                        onChange={
                                          (e) => {
                                            recordChange(entitlement.id, { revoked: e.target.checked });
                                            setEntitlements(prev => prev.map(ent => ent.id === entitlement.id ? { ...ent, revoked: e.target.checked } : ent));
                                          }
                                        }
                              />
                                </td>
                                <td style={tdStyle}>
                                    <input
                                        type="text"
                                        value={entitlement.notes ?? ''}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            recordChange(entitlement.id, {notes: val});
                                            setEntitlements(prev => prev.map(e => e.id === entitlement.id ? {...e, notes: val} : e));
                                        }}
                                        style={{...tableInputStyle, width: 150}}
                                    />
                                </td>
                                <td style={tdStyle}>
                                    {entitlement.activation_keys && entitlement.activation_keys.length > 0
                                        ? entitlement.activation_keys.map(k => <div key={k.key} style={{marginBottom: 8}}>{k.key}</div>)
                                        : "-"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <hr style={hrStyle}/>
                <div style={{display: 'flex', gap: 8}}>
                    <button className='ManagePage-AddButton' style={{width: 50}} onClick={() => setShowAddModal(true)} disabled={allProducts.length === 0 || !assigneeId}>+</button>
                    {hasChanges && <button className='ManagePage-SaveButton' onClick={saveChanges}>{saveText}</button>}
                </div>
                {showAddModal && (
                    <AddEntitlementModal
                        availableProducts={allProducts}
                        allFeatures={allFeatures}
                        addEndpoint={addEndpoint}
                        onClose={() => setShowAddModal(false)}
                        onAdded={(ent) => setEntitlements(prev => [...prev, ent])}
                    />
                )}
            </div>
        </div>
    );
}


function UserInfo({users, selectedUser, reloadTable, userGroups}) {
    return (
        <div style={{
            display:'grid',
            gridTemplateRows:'10px 10px 200px 10px auto',
            overflowY: 'auto',
        }}>
            <div/>
            <hr style={hrStyle}/>
            <UserDetails selectedUser={selectedUser} reloadTable={reloadTable} userGroups={userGroups}/>
            <hr style={hrStyle}/>
            <EntitlementsSection
                assigneeId={selectedUser}
                listEndpoint={'/api/entitlements/' + selectedUser}
                addEndpoint={'/api/addEntitlement/' + selectedUser}
            />
        </div>
    )
}



function UsersTable({users, selectedUser, setSelectedUser, setShowAddNewUser}) {
    const selectRow = (event) => {
        if (event.target.id)
            setSelectedUser(event.target.id);
        else if (event.target.parentElement.id)
            setSelectedUser(event.target.parentElement.id);
        else
            setSelectedUser('');
    }

    const removeSelectedUser = () => {
        const token = localStorage.getItem('token');
        axios.delete('/api/removeUser/', {
            headers: {
                'Authorization': `Token ${token}`,
                'Content-Type': 'application/json'
            },
            params: {'user': selectedUser}
        })
        .then(response => {
            setSelectedUser('')
        })
        .catch(error => {
            console.log("Error", error);
            setSelectedUser(selectedUser);
        });
    }


    return (
        <div style={{
            display: 'grid',
            justifyContent:'start',
            gridTemplateColumns: '200px',
            gridTemplateRows: "10px 10px 600px 10px 20px",
            gridGap: '0px',
            margin:0,
        }}>
            <label style={{textAlign:'left', fontWeight:'bold', fontSize:10}}> All Users</label>
            <hr style={hrStyle}/>
            <div>
                <table style={{ overflowY:'scroll', height:'100%', display:"block"}}>
                    <thead>
                        <tr style={{borderRadius:'2px', justifyItems:'start'}}>
                            <th style={{ padding:'0px', borderRadius:'2px', width:'200px'}}>
                                <label style={{textAlign:'left', borderRadius:'2px',  fontSize:10}} > NAME </label>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        users.map((user) => {
                            const selectedColor = user.username === selectedUser ? '#3c3c3c' : 'black';
                            return (
                                <tr style={{borderRadius:'2px', justifyItems:'start', backgroundColor:selectedColor}} key={user.username} onClick={selectRow}>
                                    <td style={{ padding:'5px', borderRadius:'2px', width:'200px'}} key={user.username+1} id={user.username}>
                                        <label style={{textAlign:'left', borderRadius:'2px',  fontSize:12, backgroundColor:selectedColor}} id={user.username} key={user.username+2}>{user.firstname} {user.lastname}</label>
                                    </td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
            <hr style={hrStyle}/>
            <div style={{display:'grid', gridTemplateColumns:'30px 30px', justifyContent:'end'}}>
                <button className='ManagePage-AddButton' onClick={()=>{
                    if (window.confirm('Are you sure you want to remove user ' + selectedUser + "?"))
                        removeSelectedUser()
                }}>-</button>
                <button className='ManagePage-AddButton' onClick={()=>{
                    setShowAddNewUser(true);
                }}>+</button>
            </div>
        </div>
    )
}



function GroupInfo({selectedGroup, userGroups}) {
    const group = userGroups.find(g => String(g.id) === String(selectedGroup));

    return (
        <div style={{
            display:'grid',
            gridTemplateRows:'10px 10px 30px 10px auto',
            overflowY: 'auto',
        }}>
            <div/>
            <hr style={hrStyle}/>
            <div style={{
                display:'grid',
                gridTemplateColumns: '100px 400px',
            }}>
                <div>
                    <label style={sectionLabelStyle}>GROUP</label>
                </div>
                <div style={{margin: 10, color:'#969696', fontSize:12}}>
                    {group ? group.name : ''}
                </div>
            </div>
            <hr style={hrStyle}/>
            <EntitlementsSection
                assigneeId={selectedGroup}
                listEndpoint={'/api/groupEntitlements/' + selectedGroup}
                addEndpoint={'/api/addGroupEntitlement/' + selectedGroup}
            />
        </div>
    )
}


function ManagePage() {
    const [showAddNewUser, setShowAddNewUser] = useState(false);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [userGroups, setUserGroups] = useState([]);
    const [selectedUserGroups, setSelectedUserGroups] = useState('');


    const reloadUserTable = useCallback(() => {
        const token = localStorage.getItem("token");
        axios.get('/api/users', {
            headers: {'Authorization': `Token ${token}`},
            params: {'usergroupid': selectedUserGroups}
        })
        .then(response => {
            if (response.status === 200) {
                setUsers(response.data.userList);
            }
        })
        .catch(error => {
            console.log(error)
            setUsers([]);
        });
    }, [selectedUserGroups])


    const reloadUserGroupTable = useCallback(() => {
        const token = localStorage.getItem("token");
        axios.get('/api/userGroups/', {
            headers: {
                'Authorization': `Token ${token}`,
                'Content-Type': 'application/json'
            },
        })
        .then(response => {
            if (response.status === 200) {
                setUserGroups(response.data.results);
            }
        })
        .catch(error => {
            console.log(error)
            setUsers([]);
        });
    }, [])


    useEffect(() => {
        reloadUserTable();
        reloadUserGroupTable();
    }, [selectedUser, selectedUserGroups, reloadUserTable, reloadUserGroupTable])


    if (showAddNewUser)
        return <NewUserModal setShowAddNewUser={setShowAddNewUser} setSelectedUser={setSelectedUser} selectedUser={selectedUser} reloadTable={reloadUserTable}/>;

    return (
        <div style={{padding: '0 20px', marginTop: 60}}>
            <div style={{
                display:'grid',
                gridTemplateColumns:'200px 200px auto',
                gridTemplateRows: '60vh',
                columnGap: 20,
                maxWidth: 1700,
                margin: '0 auto',
                marginBottom: 20,
            }}>
                <UserGroupList userGroups={userGroups} selectedUserGroup={selectedUserGroups} setSelectedUserGroup={setSelectedUserGroups} setSelectedUser={setSelectedUser} reloadUserGroupTable={reloadUserGroupTable} reloadUserTable={reloadUserTable}/>
                <UsersTable setShowAddNewUser={setShowAddNewUser} users={users} selectedUser={selectedUser} setSelectedUser={setSelectedUser}/>
                {selectedUser
                    ? <UserInfo users={users} selectedUser={selectedUser} setSelectedUser={setSelectedUser} reloadTable={reloadUserTable} userGroups={userGroups}/>
                    : (selectedUserGroups
                        ? <GroupInfo selectedGroup={selectedUserGroups} userGroups={userGroups}/>
                        : <div/>)}
            </div>
        </div>
    )
}
export default ManagePage
